module.exports = __webpack_public_path__ + "static/img/qrcode.fa9e3ee5.jpg";